import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { OutboundEvent, WebSocketRequest,  } from '../../store/websocket/websocket.models';

@Injectable({
  providedIn: 'root',
})
export class WebSocketService {
  private socket: WebSocket | null = null;
  private eventsSubject = new Subject<OutboundEvent>();
  private openSubject = new Subject<void>();
  private closeSubject = new Subject<void>();
  private errorSubject = new Subject<string>();

  events$: Observable<OutboundEvent> = this.eventsSubject.asObservable();
  open$: Observable<void> = this.openSubject.asObservable();
  close$: Observable<void> = this.closeSubject.asObservable();
  error$: Observable<string> = this.errorSubject.asObservable();

  connect(url: string, token: string): void {
    if (this.socket && this.socket.readyState === WebSocket.OPEN) {
      return;
    }

    if (this.socket && this.socket.readyState === WebSocket.CONNECTING) {
      return;
    }

    const wsUrl = `${url}?token=${encodeURIComponent(token)}`;
    this.socket = new WebSocket(wsUrl);

    this.socket.onopen = () => {
      this.openSubject.next();
    };

    this.socket.onmessage = (event: MessageEvent<string>) => {
      try {
        const parsed = JSON.parse(event.data) as OutboundEvent;
        this.eventsSubject.next(parsed);
      } catch {
        this.errorSubject.next('Failed to parse websocket event');
      }
    };

    this.socket.onerror = () => {
      this.errorSubject.next('WebSocket connection error');
    };

    this.socket.onclose = () => {
      this.closeSubject.next();
    };
  }

  send(request: WebSocketRequest): void {
    if (!this.socket || this.socket.readyState !== WebSocket.OPEN) {
      throw new Error('WebSocket is not connected');
    }

    this.socket.send(JSON.stringify(request));
  }

  disconnect(): void {
    if (this.socket) {
      this.socket.close();
      this.socket = null;
    }
  }

  isConnected(): boolean {
    return this.socket?.readyState === WebSocket.OPEN;
  }
}